import React from "react";
import { Modal, Button } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const ConfirmationModal = ({ open, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", confirmButtonAppearance = "primary", isDelete = false }) => {
  return (
    <Modal open={open} onClose={onClose} size="sm">
      <Modal.Header>
        <Modal.Title>{title || "Confirm Action"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message || "Are you sure you want to proceed?"}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="subtle">
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          appearance={confirmButtonAppearance}
          style={isDelete ? { backgroundColor: '#dc3545', color: 'white' } : {}}
        >
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;

